<div class="ShippingMainContent">

  <div class="overlay" *ngIf="AskForShipmentConnection || ShowAddNewPartner || ShowCompareShippingCostsContainer;"></div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="AskForShipmentConnection">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="AskForShipmentConnection = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'AskForShipmentConnection' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'AskForShipmentConnectionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="AskForShipmentConnection = false; SelectHistoryTracking(this.CurrentHistoricalShipment, false)">{{ 'DontConnect' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="AskForShipmentConnection = false;SelectHistoryTracking(this.CurrentHistoricalShipment, true);">{{ 'ConnectShipments' | translate }}</button>
    </div>
</div>

  <!-- ✅ Modern Document Connection Pre-check Popup -->
  <div class="ModernPopupOverlay" *ngIf="ShowDocumentPrecheck" (click)="ShowDocumentPrecheck = false;">
    <div class="ModernPopup DocumentPrecheckPopup" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #4a7bb8;">link</i>
          <span>{{ ShippingDetails?.ShippingDirection?.ID == 1 ? ('UnlinkedInvoicesFound' | translate) : ('UnlinkedReceptionsFound' | translate) }}</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowDocumentPrecheck = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Body -->
      <div class="DocumentPrecheckBody">
        <p class="DocumentPrecheckDescription">
          {{ ShippingDetails?.ShippingDirection?.ID == 1 ? ('UnlinkedInvoicesDescription' | translate) : ('UnlinkedReceptionsDescription' | translate) }}
        </p>

        <div class="EmailSectionLabel">
          <i class="material-icons">description</i>
          <span>{{ ShippingDetails?.ShippingDirection?.ID == 1 ? ('Invoices' | translate) : ('ReceptionsWord' | translate) }}</span>
        </div>

        <div class="DocumentPrecheckChipList">
          <div class="DocumentPrecheckChip"
               *ngFor="let doc of UnlinkedDocuments"
               [class.selected]="SelectedUnlinkedDocument?.ID == doc.ID"
               (click)="SelectUnlinkedDocument(doc)">
            <i class="material-icons DocumentPrecheckChipIcon">{{ SelectedUnlinkedDocument?.ID == doc.ID ? 'check_circle' : 'radio_button_unchecked' }}</i>
            <div class="DocumentPrecheckChipContent">
              <div class="DocumentPrecheckChipMain">
                <span class="DocumentPrecheckChipNumber">{{ doc.DocumentNumber }}</span>
                <span class="DocumentPrecheckChipType">{{ doc.DocumentType }}</span>
              </div>
              <div class="DocumentPrecheckChipMeta">
                <span *ngIf="doc.SupplierDocNumber">{{ 'SupplierDocNumber' | translate }}: {{ doc.SupplierDocNumber }}</span>
                <span>{{ doc.PartnerName }}</span>
                <span>{{ doc.EventRegisterUI }}</span>
                <span *ngIf="doc.TotalValue">{{ doc.TotalValue | number:'1.2-2' }} {{ doc.CurrencyName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="ModernPopupFooter">
        <div class="GridCommandButton" (click)="SkipDocumentPrecheck()">
          <i class="material-icons" style="color: #5a7a9a;">skip_next</i>
          <span>{{ 'SkipConnection' | translate }}</span>
        </div>
        <div class="GridCommandButton" [class.disabled]="!SelectedUnlinkedDocument" (click)="ConfirmDocumentPrecheck()">
          <i class="material-icons" style="color: #34d399;">link</i>
          <span style="color: #1a3a5c;">{{ 'ConnectAndCreate' | translate }}</span>
        </div>
      </div>

    </div>
  </div>

    <div class="ComparationContainer animated fadeInDown" *ngIf="this.ShowCompareShippingCostsContainer == true;">
      <div class="ComparationContainerClose" (click)="this.ShowCompareShippingCostsContainer = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="ComparationContainerTitle">
        {{'CompareShippingCosts' | translate}}
      </div>
      <div class="ComparationContainerBody">
        <div class="ComparationRow" *ngFor="let s of this.ComparingShippingDetails;let i = index;" (click)="SelectShippingCompany(s.ShippingCompany); SelectComparingShippingDetailsShippingCompany(s.ShippingCompany);" [ngClass]="{'SelectedShippingCompany': s.ShippingCompany.IsSelected == true}">
          <div class="ComparationRowIcon">
            <i class="material-icons" *ngIf="s.ShippingCompany.IsSelected == true;" style="color: #0082e6;">radio_button_on</i>
            <i class="material-icons" *ngIf="s.ShippingCompany.IsSelected == false;">radio_button_off</i>
          </div>
          <div class="ComparationRowImage">
            <img [src]="this.parent.BackendServiceUrl + s.ShippingCompany.ImagePath">
          </div>
          <div class="ComparationRowInfo">
            <p>{{s.ShippingCompany.Name}}</p>
            <p *ngIf="s.Price != null;">{{'ShippingCost' | translate}}:
              <span *ngIf="s.PriceContainsVAT == true;">{{s.Price?.UIVATUnitPrice}} {{s.Price?.Currency?.Name}}</span>
              <span *ngIf="s.PriceContainsVAT != true;">{{s.Price?.UIUnitPrice}} {{s.Price?.Currency?.Name}} {{'Receptions.Table.PriceNOVAT' | translate}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="ComparationContainerCommands">

        <div class="ComparationContainerCommandsRow">
          <div class="DirectionTabsWrapper">
            <div *ngFor="let dir of this.Directions"
                 class="DirectionTab noselect"
                 [ngClass]="{'SelectedDirectionTab ExportColor': dir.ID == this.ShippingDetails.ShippingDirection?.ID && dir.ID == 1,
                             'SelectedDirectionTab ImportColor': dir.ID == this.ShippingDetails.ShippingDirection?.ID && dir.ID == -1}"
                 (click)="SelectShippingDirection(dir);">
              <!-- Export (ID = 1) -->
              <i class="material-icons" *ngIf="dir.ID == 1;">arrow_upward</i>
              <!-- Import (ID = -1) -->
              <i class="material-icons" *ngIf="dir.ID == -1;">arrow_downward</i>
              <!-- Fallback -->
              <i class="material-icons" *ngIf="dir.ID != -1 && dir.ID != 1;">check</i>
              <span>{{dir.Name}}</span>
            </div>
          </div>
        </div>

        <div class="ComparationContainerCommandsRow">
          <div *ngFor="let service of this.ShippingServiceTypes" class="SelectedOption" (click)="SelectGeneralShippingServiceType(service);">
            <!-- Standard/Road shipping (ID = -1) -->
            <i class="material-icons" *ngIf="service.IsSelected == true && service.ID == -1;">local_shipping</i>
            <i class="material-icons" *ngIf="service.IsSelected != true && service.ID == -1;" style="color: #fff;">local_shipping</i>
            <!-- Express/Air shipping (ID = 1) -->
            <i class="material-icons" *ngIf="service.IsSelected == true && service.ID == 1;">flight_takeoff</i>
            <i class="material-icons" *ngIf="service.IsSelected != true && service.ID == 1;" style="color: #fff;">flight_takeoff</i>
            <!-- Fallback for other types -->
            <i class="material-icons" *ngIf="service.IsSelected == true && service.ID != -1 && service.ID != 1;">check</i>
            <i class="material-icons" *ngIf="service.IsSelected != true && service.ID != -1 && service.ID != 1;" style="color: #fff;">check</i>
            <span>{{service.Name}}</span>
          </div>
        </div>

        <button mat-raised-button class="CompareButton" [disabled]="this.parent.loading == true" (click)="CompareShippingCosts();" *ngIf="ComparationCompleted != true;">
          <i class="material-icons">local_shipping</i>
          <i class="material-icons">linear_scale</i>
          <span>{{'CompareShippingCosts' | translate}}</span>
        </button>

        <button mat-raised-button class="CompareButton" style="background: #32aa3a;" [disabled]="this.parent.loading == true" (click)="AcceptComparedShippingCompany();" *ngIf="ComparationCompleted == true;">
          <i class="material-icons">check</i>
          <span>{{'ChooseShippingCompany' | translate}}</span>
        </button>
      </div>
    </div>

    <div class="AddNewPartnerContainer animated fadeInDown" *ngIf="ShowAddNewPartner == true;">
        <div class="AddNewPartnerContainerTitle">
          {{'AddNewPartner' | translate}}
        </div>
        <div class="AddNewPartnerContainerClose" (click)="ShowAddNewPartner = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="AddNewPartnerContainerBody">

          <p class="NewTextBoxContainerTitle">{{'Name' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
            <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ContactCompany" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
            <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ContactPerson" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
            <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.VATNumber" matInput>
          </div>
  
          <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.NewPartnerAddress != null && this.NewPartnerAddress?.ID != null && this.Countries?.length > 0;">
            <p class="NewTextBoxContainerTitle">{{'SearchCountries' | translate}}</p>
            <div class="NewTextBoxContainer" style="width: 90%;">
              <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
              <div class="NewTextBoxImageContainer" *ngIf="this.NewPartnerAddress?.Country?.FlagURL?.length > 0;">
                <img [src]="this.NewPartnerAddress.Country.FlagURL">
              </div>
              <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Country.Name" matInput (ngModelChange)="this.countryTermUpdate.next($event)" (click)="InitializeNewAddressCountrySearch();">
              <i class="material-icons" *ngIf="!(this.NewPartnerAddress.Country.Name?.length > 0) && !loadingCountry;">search</i>
              <i class="material-icons" style="color:red;" *ngIf="this.NewPartnerAddress.Country.Name?.length > 0 && !loadingCountry;" (click)="DeselectNewAddressCountry();">close</i>
            
              <div class="CentralSearchResultsContainer" *ngIf="this.FilteredCountries?.length > 0;">
                <div *ngFor="let c of this.FilteredCountries;" class="PartnersSearchResultText" (click)="SelectNewPartnerAddressCountry(c);">
                    <div class="FilteredCountriesImageContainer">
                      <img [src]="c.FlagURL">
                    </div>
                    <div class="FilteredCountriesName">{{c.Name}}</div>
                </div>
              </div>
            </div>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.State" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.City" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Address' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.AddressLine" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ZipCode" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Email" matInput>
          </div>
  
          <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
          <div class="NewTextBoxContainer" style="width: 90%;">
              <input (input)="ProofNewPartnerAddress();" disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Phone" matInput>
          </div>

        </div>

        <div class="AddNewPartnerContainerCommands">
          <div class="SelectedOption" style="margin-left: 5%;margin-top: 25px;" *ngIf="AddNewPartnerValid == true && LoadingAddNewPartnerFromShippingAddress == false;" (click)="AddNewPartnerFromShippingAddress();">
            <i class="material-icons">check</i>
            <span>{{'AddNewPartner' | translate}}</span>
          </div>

          <div class="SelectedOptionNotValid" style="margin-left: 5%;margin-top: 25px;" *ngIf="AddNewPartnerValid == false;">
            <i class="material-icons">close</i>
            <span>{{'AddNewPartner' | translate}}</span>
          </div>

          <div class="SelectedOption" style="margin-left: 5%;margin-top: 25px;background: #ddd;color: #aaa;" *ngIf="AddNewPartnerValid == true && LoadingAddNewPartnerFromShippingAddress == true;">
            <i class="material-icons">check</i>
            <span>{{'AddNewPartner' | translate}}</span>
          </div>
        </div>
    </div>

    <!-- ✅ Modern Email Settings Popup -->
    <div class="ModernPopupOverlay" *ngIf="ShowEmailSettings" (click)="CloseEmailSettings();">
      <div class="ModernPopup EmailSettingsPopup" (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons" style="color: #4a7bb8;">mail_outline</i>
            <span>{{'EmailSettings' | translate}}</span>
          </div>
          <button class="ModernPopupClose" (click)="CloseEmailSettings();">
            <i class="material-icons">close</i>
          </button>
        </div>

        <!-- Body -->
        <div class="EmailSettingsBody">

          <!-- SMTP & Send From Dropdowns -->
          <div class="EmailSettingsSection">
            <div class="CustomDropdownContainer">
              <div class="DropdownOverlayTransparent" *ngIf="showSMTPDropdown" (click)="showSMTPDropdown = false"></div>
              <div class="CustomDropdownBar disabled">
                <span class="dropdown-label">{{ 'SMTP' | translate }}</span>
                <i class="material-icons dropdown-icon-left">dns</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrenctSMTP?.SMTPServer" [value]="CurrenctSMTP?.SMTPServer || ('SMTP' | translate)" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
            </div>

            <div class="CustomDropdownContainer">
              <div class="DropdownOverlayTransparent" *ngIf="showSendFromDropdown" (click)="showSendFromDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showSendFromDropdown = !showSendFromDropdown;">
                <span class="dropdown-label">{{ 'SendFrom' | translate }}</span>
                <i class="material-icons dropdown-icon-left">forward_to_inbox</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!CurrentSMTPEmail?.Email" [value]="CurrentSMTPEmail?.Email || ('SendFrom' | translate)" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showSendFromDropdown">
                <div class="CustomDropdownResult" *ngFor="let e of SMTPEmails" (click)="CurrentSMTPEmail = e; showSendFromDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <span class="CustomDropdownResultText">{{e.Email}}</span>
                  </div>
                  <i class="material-icons CustomDropdownResultCheck" *ngIf="CurrentSMTPEmail?.ID === e.ID">check</i>
                  <i class="material-icons CustomDropdownResultX" *ngIf="CurrentSMTPEmail?.ID !== e.ID">close</i>
                </div>
              </div>
            </div>
          </div>

          <!-- Recipients -->
          <div class="EmailSettingsSection">
            <div class="EmailSectionLabel">
              <i class="material-icons">group</i>
              <span>{{'SendTo' | translate}}</span>
            </div>
            <div class="EmailRecipientsList">
              <div class="EmailRecipientChip" *ngFor="let e of this.CurrentPartner?.PartnerAgents"
                   [class.selected]="e.IsSelected == true"
                   (click)="e.IsSelected = !e.IsSelected;">
                <i class="material-icons EmailRecipientChipIcon">{{e.IsSelected == true ? 'check_circle' : 'radio_button_unchecked'}}</i>
                <span>{{e.Email}}</span>
              </div>
            </div>
          </div>

          <!-- Subject & Message -->
          <div class="EmailSettingsSection" *ngIf="this.EmailMessage?.EmailModel">
            <div class="EmailSectionLabel">
              <i class="material-icons">edit</i>
              <span>{{'SubjectEmail' | translate}}</span>
            </div>
            <div class="EmailModernInputGroup">
              <input type="text" class="EmailModernInput" autocomplete="off" [(ngModel)]="this.EmailMessage.EmailModel.Subject" [placeholder]="'SubjectEmail' | translate" />
            </div>

            <div class="EmailSectionLabel" style="margin-top: 16px;">
              <i class="material-icons">article</i>
              <span>{{'Message' | translate}}</span>
            </div>
            <div class="EmailModernInputGroup">
              <textarea class="EmailModernTextarea" autocomplete="off" rows="8" [(ngModel)]="this.EmailMessage.EmailModel.DefaultMessage" [placeholder]="'Message' | translate"></textarea>
            </div>
          </div>

        </div>

        <!-- Footer -->
        <div class="ModernPopupFooter">
          <div class="GridCommandButton" (click)="CloseEmailSettings();" matTooltip="{{ 'SendEmailUponLabelGeneration' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <i class="material-icons" style="color: #4a7bb8;">verified</i>
            <span style="color: #1a3a5c;">{{'AcceptSettings' | translate}}</span>
          </div>
        </div>

      </div>
    </div>

    <!-- ✅ Modern Delete Box Confirmation Popup -->
    <div class="ModernPopupOverlay" *ngIf="ShowDeleteBoxQuestion" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">
      <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons" style="color: #ef4444;">remove_circle_outline</i>
            <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="ModernPopupBody" style="min-height: auto; padding: 20px;">
          <p class="ModernPopupMessage">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
        </div>
        <div class="ModernPopupFooter">
          <div class="GridCommandButton" [class.disabled]="this.parent.loading" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">
            <i class="material-icons">close</i>
            <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
          </div>
          <div class="GridCommandButton GridCommandButtonRed" [class.disabled]="this.parent.loading" (click)="ShowDeleteBoxQuestion = false; DeleteBox(CurrentBox);">
            <i class="material-icons">remove_circle_outline</i>
            <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ✅ Shipping Label Error Popup (e.g. mixed pallets + boxes) -->
    <div class="ModernPopupOverlay" *ngIf="ShowShippingLabelError" (click)="ShowShippingLabelError = false;">
      <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons" style="color: #f59e0b;">warning</i>
            <span>{{ 'ShippingLabelError' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="ShowShippingLabelError = false;">
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="ModernPopupBody" style="min-height: auto; padding: 20px;">
          <p class="ModernPopupMessage">{{ ShippingLabelErrorMessage }}</p>
        </div>
        <div class="ModernPopupFooter">
          <div class="GridCommandButton" (click)="ShowShippingLabelError = false;">
            <i class="material-icons" style="color: #4a7bb8;">check</i>
            <span style="color: #1a3a5c;">OK</span>
          </div>
        </div>
      </div>
    </div>

    <div class="HalfContentTitle">
        {{'NewShipment' | translate}} - {{this.ShippingDetails?.ShippingCompany.Name}}
    </div>

    <div class="ShippingCompanySelectContainer">
        <div class="ShippingCompany" *ngFor="let s of this.ShippingCompanies;let i = index;" (click)="SelectShippingCompany(s);" [ngClass]="{'SelectedShippingCompany': s.IsSelected == true}">
            <div class="ShippingCompanyIcon">
                <i class="material-icons" *ngIf="s.IsSelected == true;" style="color: #0082e6;">radio_button_on</i>
                <i class="material-icons" *ngIf="s.IsSelected == false;">radio_button_off</i>
            </div>
            <div class="ShippingCompanyImage">
                <img [src]="this.parent.BackendServiceUrl + s.ImagePath">
            </div>
        </div>

        <div class="SelectedOptionsContainer" *ngIf="!ShippingDetails.TrackingLabel?.length;">
            <div class="DirectionTabsWrapper DirectionTabsCentered">
                <div *ngFor="let dir of this.Directions"
                     class="DirectionTab noselect"
                     [class.SelectedDirectionTab]="dir.ID == this.ShippingDetails.ShippingDirection?.ID"
                     [class.ExportColor]="dir.ID == this.ShippingDetails.ShippingDirection?.ID && dir.ID == 1"
                     [class.ImportColor]="dir.ID == this.ShippingDetails.ShippingDirection?.ID && dir.ID == -1"
                     (click)="SelectShippingDirection(dir);">
                    <!-- Export (ID = 1) -->
                    <i class="material-icons" *ngIf="dir.ID == 1;">arrow_upward</i>
                    <!-- Import (ID = -1) -->
                    <i class="material-icons" *ngIf="dir.ID == -1;">arrow_downward</i>
                    <!-- Fallback -->
                    <i class="material-icons" *ngIf="dir.ID != -1 && dir.ID != 1;">check</i>
                    <span>{{dir.Name}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="HalfContent" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && !TaskCompleted;" style="width: 45%;">
        <div class="SenderTitle">
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'Sender' | translate}}</span>
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'Receiver' | translate}}</span>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.CompanyShippingAddresses?.length > 0;">
          <p class="NewTextBoxContainerTitle">{{'ShippingAddresses' | translate}}</p>
          <div class="NewTextBoxContainer">
            <input type="text" autocomplete="off" class="NewTextBox" matInput (click)="OpenCloseShowAllCompanyAddresses();" [(ngModel)]="this.SelectedCompanyAddressLine">
            <i class="material-icons">keyboard_arrow_down</i>

            <div class="CentralSearchResultsContainer" *ngIf="this.ShowAllCompanyAddresses == true;">
              <div *ngFor="let a of this.CompanyShippingAddresses;" class="PartnersSearchResultText" (click)="SelectCompanyShippingAddress(a);">
                <i class="material-icons" *ngIf="a.IsSelected == true;">check</i>
                <span>{{a.Country?.ShortName}} - {{a.City}}, {{a.ContactPerson}}</span>
              </div>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Name' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactCompany" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactPerson" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.VATNumber" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Country' | translate}}</p>
        <div class="NewTextBoxContainer">
          <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
          <div class="NewTextBoxImageContainer" *ngIf="this.Left?.Country?.FlagURL?.length > 0;">
            <img [src]="this.Left.Country.FlagURL">
          </div>
          <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.Left.Country.Name" matInput (ngModelChange)="this.countryTermUpdate2.next($event)" (click)="InitializeNewCompanyAddressCountrySearch();" *ngIf="this.Left?.Country">
          <i class="material-icons" *ngIf="this.Left?.Country && !(this.Left.Country.Name?.length > 0) && !loadingCountry;">search</i>
          <i class="material-icons" style="color:red;" *ngIf="this.Left?.Country && this.Left.Country.Name?.length > 0 && !loadingCountry;" (click)="DeselectNewCompanyAddressCountry();">close</i>
        
          <div class="CentralSearchResultsContainer" *ngIf="this.FilteredCountries2?.length > 0;">
            <div *ngFor="let c of this.FilteredCountries2;" class="PartnersSearchResultText" (click)="SelectNewCompanyAddressCountry(c);">
                <div class="FilteredCountriesImageContainer">
                  <img [src]="c.FlagURL">
                </div>
                <div class="FilteredCountriesName">{{c.Name}}</div>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.State" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.City" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Address' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.AddressLine" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ZipCode" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Email" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Phone" matInput>
        </div>
    </div>

    <div class="HalfContent" style="width: 10%;" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && !TaskCompleted;">
        <div class="SenderTitle">
            <button mat-raised-button color="primary" class="SwitchDirectionButton" (click)="SwitchDirection();">
                <i class="material-icons">compare_arrows</i>
            </button>
        </div>
    </div>

    <div class="HalfContent" style="width: 45%;" *ngIf="!TaskCompleted;">
        <div class="SenderTitle">
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'Sender' | translate}}</span>
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'Receiver' | translate}}</span>
            <span *ngIf="this.Right?.ParentPartnerCode?.length > 0;"> ({{this.Right?.ParentPartnerCode}})</span>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.Right != null && this.Right?.ID != null && this.ShippingAddresses?.length > 0;">
          <p class="NewTextBoxContainerTitle" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'PickupAddress' | translate}}</p>
          <p class="NewTextBoxContainerTitle" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'ShippingAddresses' | translate}}</p>
          <div class="NewTextBoxContainer">
            <mat-spinner *ngIf="this.LoadingShippingAddressSelection == true;" class="loadingShippingAddressSpinner" [diameter]="25"></mat-spinner>
            <input type="text" autocomplete="off" class="NewTextBox" matInput (click)="OpenCloseShowAllAddresses();" [(ngModel)]="this.SelectedAddressLine">
            <i class="material-icons" *ngIf="this.LoadingShippingAddressSelection != true;">keyboard_arrow_down</i>
          
            <div class="CentralSearchResultsContainer" *ngIf="this.ShowAllAddresses == true;">
              <div *ngFor="let a of this.ShippingAddresses;" class="PartnersSearchResultText" (click)="SelectShippingAddressFromUI(a);">
                <i class="material-icons" *ngIf="a.IsSelected == true;">check</i>
                <span>{{a.Country.ShortName}} - {{a.City}}, {{a.ContactPerson}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;">
            <p class="NewTextBoxContainerTitle">{{'SearchPartners' | translate}}</p>
            <div class="NewTextBoxContainer">
              <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
              <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
              <i class="material-icons" *ngIf="!(this.Filter.SearchTerm?.length > 0) && !loadingShipment;">search</i>
              <i class="material-icons" style="color:red;" *ngIf="this.Filter.SearchTerm?.length > 0 && !loadingShipment;" (click)="DeselectPartner();">close</i>
            
              <div class="CentralSearchResultsContainer" *ngIf="Partners?.length > 0;">
                <div *ngFor="let p of this.Partners;" class="PartnersSearchResultText" (click)="SelectPartner(p);">
                    {{p.Name}}
                </div>
              </div>
            </div>

            <div class="AddNewPartnerWhiteButton" (click)="ShowAddNewPartnerContainer();" *ngIf="(this.Right != null) == false && this.Filter.SearchTerm?.length > 0 && (this.Partners?.length > 0) == false;">
              <i class="material-icons">person_add_alt_1</i>
            </div>
        </div>

        <div *ngIf="this.Right != null;">
          <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
        <div class="NewTextBoxContainer">
        <input type="text" class="NewTextBox" [(ngModel)]="this.Right.ContactPerson" matInput (input)="updateRightChanged();">
        </div>
        </div>
       
        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.VATNumber" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.Right != null && this.Right?.ID != null && this.Countries?.length > 0;">
          <p class="NewTextBoxContainerTitle">{{'SearchCountries' | translate}}</p>
          <div class="NewTextBoxContainer">
            <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
            <div class="NewTextBoxImageContainer" *ngIf="this.Right?.Country?.FlagURL?.length > 0;">
              <img [src]="this.Right?.Country?.FlagURL">
            </div>
            <input (input)="updateRightChanged();" type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.Right.Country.Name" matInput (ngModelChange)="this.countryTermUpdate.next($event)" (click)="InitializeCountrySearch();">
            <i class="material-icons" *ngIf="!(this.Right.Country.Name?.length > 0) && !loadingCountry;">search</i>
            <i class="material-icons" style="color:red;" *ngIf="this.Right.Country.Name?.length > 0 && !loadingCountry;" (click)="DeselectCountry();">close</i>
          
            <div class="CentralSearchResultsContainer" *ngIf="this.FilteredCountries?.length > 0;">
              <div *ngFor="let c of this.FilteredCountries;" class="PartnersSearchResultText" (click)="SelectCountry(c);updateRightChanged();">
                <div class="FilteredCountriesImageContainer">
                  <img [src]="c.FlagURL">
                </div>
                <div class="FilteredCountriesName">{{c.Name}}</div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.State" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.City" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'AddressLine' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.AddressLine" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
            <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.ZipCode" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
          <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
        <div class="NewTextBoxContainer">
        <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.Email" matInput (input)="updateRightChanged();">
        </div>
        </div>

        <div *ngIf="this.Right != null;">
          <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
        <div class="NewTextBoxContainer">
        <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Right.Phone" matInput (input)="updateRightChanged();">
        </div>
        </div>
        
    </div>

    <div class="HalfContent" style="width: 10%;" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && !TaskCompleted;">
        <div class="SenderTitle">
            <button mat-raised-button color="primary" class="SwitchDirectionButton" (click)="SwitchDirection();">
                <i class="material-icons">compare_arrows</i>
            </button>
        </div>
    </div>

    <div class="HalfContent" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && !TaskCompleted;" style="width: 45%;">
        <div class="SenderTitle">
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;">{{'Sender' | translate}}</span>
            <span *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1;">{{'Receiver' | translate}}</span>
        </div>

        <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.CompanyShippingAddresses?.length > 0;">
          <p class="NewTextBoxContainerTitle">{{'ShippingAddresses' | translate}}</p>
          <div class="NewTextBoxContainer">
            <input type="text" autocomplete="off" class="NewTextBox" matInput (click)="OpenCloseShowAllCompanyAddresses();" [(ngModel)]="this.SelectedCompanyAddressLine">
            <i class="material-icons">keyboard_arrow_down</i>

            <div class="CentralSearchResultsContainer" *ngIf="this.ShowAllCompanyAddresses == true;">
              <div *ngFor="let a of this.CompanyShippingAddresses;" class="PartnersSearchResultText" (click)="SelectCompanyShippingAddress(a);">
                <i class="material-icons" *ngIf="a.IsSelected == true;">check</i>
                <span>{{a.Country?.ShortName}} - {{a.City}}, {{a.ContactPerson}}</span>
              </div>
            </div>
          </div>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Name' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactCompany" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ContactPerson" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
        <div class="NewTextBoxContainer">
          <input type="text" class="NewTextBox" [(ngModel)]="this.Left.VATNumber" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Country' | translate}}</p>
        <div class="NewTextBoxContainer" *ngIf="this.Left?.Country?.ID > 0">
            <div class="NewTextBoxImageContainer" *ngIf="this.Left?.Country?.FlagURL?.length > 0;">
              <img [src]="this.Left.Country.FlagURL">
            </div>
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.Country.Name" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.State" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.City" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Address' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.AddressLine" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input type="text" class="NewTextBox" [(ngModel)]="this.Left.ZipCode" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Email" matInput>
        </div>

        <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
        <div class="NewTextBoxContainer">
            <input disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.Left.Phone" matInput>
        </div>
    </div>

    <div class="TransportSection" *ngIf="this.parent?.Company?.ID > 0 && !TaskCompleted && this.CurrentPartner?.ID != null;">
      <div class="HalfContent" style="width: 45%;min-height: 50px;">
        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && this.Right?.ID != 0;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">check</i>
          <span>{{'UpdatePartnerAddress' | translate}}</span>
        </button>

        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && this.Right?.ID == 0;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddNewAddress' | translate}}</span>
        </button>

        <button style="background: #32aa3a;color: #fff;" mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID != 1 && this.RightChanged == true;" (click)="this.Right.ID = 0; AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddAsNewAddress' | translate}}</span>
        </button>
     
      </div>

      <div class="HalfContent" style="width: 10%;min-height: 50px;">
       
      </div>

      <div class="HalfContent" style="width: 45%;min-height: 50px;">
        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && this.Right?.ID != 0;" style="margin-left:6%;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">check</i>
          <span>{{'UpdatePartnerAddress' | translate}}</span>
        </button>

        <button mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && this.Right?.ID == 0;" style="margin-left:6%;" (click)="AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddNewAddress' | translate}}</span>
        </button>

        <button style="background: #32aa3a;color: #fff;" mat-raised-button class="AddressButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1 && this.RightChanged == true;" (click)="this.Right.ID = 0; AddUpdateShippingAddress(this.Right);">
          <i class="material-icons">add</i>
          <span>{{'AddAsNewAddress' | translate}}</span>
        </button>
      </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted && this.ShippingDetails?.ShippingCompany?.ShippingServiceTypes?.length > 0;">
        <div class="SectionTitle">
            {{'ShippingServices' | translate}}
        </div>

        <div class="SelectedOptionsContainer">
            <div *ngFor="let service of this.ShippingDetails.ShippingCompany.ShippingServiceTypes" class="SelectedOption" (click)="SelectShippingServiceType(service);">
                <!-- Standard/Road shipping (ID = -1) -->
                <i class="material-icons" *ngIf="service.IsSelected == true && service.ID == -1;">local_shipping</i>
                <i class="material-icons" *ngIf="service.IsSelected != true && service.ID == -1;" style="color: #fff;">local_shipping</i>
                <!-- Express/Air shipping (ID = 1) -->
                <i class="material-icons" *ngIf="service.IsSelected == true && service.ID == 1;">flight_takeoff</i>
                <i class="material-icons" *ngIf="service.IsSelected != true && service.ID == 1;" style="color: #fff;">flight_takeoff</i>
                <!-- Fallback for other types -->
                <i class="material-icons" *ngIf="service.IsSelected == true && service.ID != -1 && service.ID != 1;">check</i>
                <i class="material-icons" *ngIf="service.IsSelected != true && service.ID != -1 && service.ID != 1;" style="color: #fff;">check</i>
                <span>{{service.Name}}</span>
            </div>
        </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted && this.ShippingDetails?.ShippingCompany?.ShippingServiceTypes?.length > 0;">
      <div class="SectionTitle">
          {{'ShippingResponsability' | translate}}
      </div>

      <div class="SelectedOptionsContainer">
        <!-- Custom Dropdown for Shipping Responsability -->
        <div class="CustomDropdownContainer">
          <div class="DropdownOverlayTransparent" *ngIf="showShippingResponsabilityDropdown" (click)="showShippingResponsabilityDropdown = false"></div>

          <div class="CustomDropdownBar" (click)="showShippingResponsabilityDropdown = !showShippingResponsabilityDropdown;">
            <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <input
              type="text"
              class="CustomDropdownInput"
              [class.placeholder]="!this.ShippingDetails.ShippingResponsability?.Name"
              [value]="this.ShippingDetails.ShippingResponsability?.Name || ('ShippingResponsability' | translate)"
              readonly
            />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>

          <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityDropdown">
            <div class="CustomDropdownResult"
                 *ngFor="let s of this.ShippingResponsabilities"
                 (click)="this.ShippingDetails.ShippingResponsability = s; showShippingResponsabilityDropdown = false;">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{s.Name}}</span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="this.ShippingDetails.ShippingResponsability?.ID === s.ID">check</i>
              <i class="material-icons CustomDropdownResultX" *ngIf="this.ShippingDetails.ShippingResponsability?.ID !== s.ID">close</i>
            </div>
          </div>
        </div>
      </div>
  </div>

    <!-- Carrier Account Selection - Shown when UsePartnerCarrierAccount is enabled and partner has ANY accounts -->
    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted && this.CurrentPartner?.ContractualConditions?.UsePartnerCarrierAccount == true && this.CurrentPartner?.ContractualConditions?.ShippingCompanyAccounts?.length > 0;">
      <div class="SectionTitle">
          {{'CarrierAccount' | translate}}
      </div>

      <div class="SelectedOptionsContainer">
        <!-- Custom Dropdown for Carrier Account - Only when accounts exist for current carrier -->
        <div class="CustomDropdownContainer" *ngIf="this.GetFilteredCarrierAccounts()?.length > 0">
          <div class="DropdownOverlayTransparent" *ngIf="showCarrierAccountDropdown" (click)="showCarrierAccountDropdown = false"></div>

          <div class="CustomDropdownBar" (click)="showCarrierAccountDropdown = !showCarrierAccountDropdown;">
            <span class="dropdown-label">{{ 'CarrierAccount' | translate }}</span>
            <i class="material-icons dropdown-icon-left">account_balance</i>
            <input
              type="text"
              class="CustomDropdownInput"
              [class.placeholder]="!this.GetSelectedCarrierAccount()"
              [value]="this.GetSelectedCarrierAccount() ? (this.GetSelectedCarrierAccount().AccountNumber + (this.FormatCarrierAccountDisplay(this.GetSelectedCarrierAccount()) ? ' | ' + this.FormatCarrierAccountDisplay(this.GetSelectedCarrierAccount()) : '')) : ('SelectCarrierAccount' | translate)"
              readonly
            />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>

          <div class="CustomDropdownResults" *ngIf="showCarrierAccountDropdown">
            <div class="CustomDropdownResult"
                 *ngFor="let account of this.GetFilteredCarrierAccounts()"
                 [class.selected]="account.IsSelected === true"
                 (click)="SelectCarrierAccount(account);">
              <div class="CustomDropdownResultMain">
                <span class="CustomDropdownResultText">{{account.AccountNumber}}</span>
                <span class="CustomDropdownResultSubText" *ngIf="this.FormatCarrierAccountDisplay(account)">
                  {{this.FormatCarrierAccountDisplay(account)}}
                </span>
              </div>
              <i class="material-icons CustomDropdownResultCheck" *ngIf="account.IsSelected === true">check</i>
              <i class="material-icons CustomDropdownResultX" *ngIf="account.IsSelected !== true">close</i>
            </div>
          </div>
        </div>

        <!-- Message when no accounts exist for current carrier -->
        <div class="NoAccountsMessage" *ngIf="this.GetFilteredCarrierAccounts()?.length === 0">
          <i class="material-icons">info</i>
          <span>{{'NoCarrierAccountsForSelectedCarrier' | translate}}</span>
        </div>
      </div>
  </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;">
        <div class="SectionTitle">
            <i class="material-icons" style="font-size: 18px; vertical-align: middle; margin-right: 5px;">straighten</i>{{'TransportedBoxesInformation' | translate}}
        </div>
        <div style="font-size: 11px; color: #888; margin: 4px 0 8px 0; font-style: italic;">
            <i class="material-icons" style="font-size: 13px; vertical-align: middle; margin-right: 3px;">info_outline</i>{{'HistoricalDimensionsDisclaimer' | translate}}
        </div>

       <div class="BoxesSearchContainer">
        <div class="B2BBodyTopSearchContainer">
          <div class="NewTextBoxContainer" style="margin: 0; width: 25%;">
            <mat-spinner *ngIf="this.HistoryLoading == true;" class="loadingShippingAddressSpinner" [diameter]="25"></mat-spinner>
            <input type="text" autocomplete="off" class="NewTextBox" matInput (click)="OpenHistoricalShipments();" placeholder="{{this.HistoryPlaceHolder}}">
            <i class="material-icons" *ngIf="this.HistoryLoading != true && this.ShowHistory == false && this.ConnectedShippingToHistoryTracking != true;">search</i>
            <i class="material-icons" *ngIf="this.ShowHistory == true;" (click)="CloseHistoricalShipments();">close</i>
            <i class="material-icons" *ngIf="this.ConnectedShippingToHistoryTracking == true;" (click)="DisconnectTrackingFromHistoricalShipment();">close</i>
          
            <div class="CentralSearchResultsContainer" *ngIf="this.ShowHistory == true;">
              <div *ngFor="let shipment of this.HistoricalShipments;" class="PartnersSearchResultText">
                  <div class="ShipmentRow" (click)="AskForDocumentConnection(shipment);">
                    <p class="ShipmentRowTitle">{{shipment.TrackingLabel}}</p>
                    <p *ngFor="let box of this.shipment.Boxes;" class="ShipmentBoxRow">{{box.Length}} x {{box.Width}} x {{box.Height}} / {{box.Weight}}KGs</p>
                  </div>
              </div>
            </div>
          </div>
        </div>
       </div>

        <button mat-raised-button color="primary" (click)="AddNewBox();" style="margin-bottom: 10px;">{{'AddNewParcel' | translate}}</button>

        <div class="ParcelContainerHeadder" *ngIf="this.ShippingDetails?.Boxes?.length > 0;">

            <div class="ParcelIndexHeadder">
                <span>#</span>
            </div>

            <div class="ParcelMultiplyHeadder">
              <span>{{ 'Multiply' | translate }}</span>
            </div>

            <div class="ParcelDimentionHeadder">
              <span>{{ 'Length' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Width' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Height' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Weight' | translate }}</span>
            </div>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <div class="ParcelDimentionHeadder">
              <span>{{ 'Pallet' | translate }}</span>
            </div>
        </div>

        <div class="ParcelContainer" *ngFor="let box of this.ShippingDetails?.Boxes; let j=index;" style="border-bottom: solid 1px #ddd;">
            <div class="ParcelIndex">
             <i class="material-icons" *ngIf="this.ShippingDetails?.ShippingServiceType?.ID == -1;">local_shipping</i>
             <i class="material-icons" *ngIf="this.ShippingDetails?.ShippingServiceType?.ID == 1;">flight_takeoff</i>
             <span style="float: left;" *ngIf="box.IsPallet != true;">{{'Parcel' | translate}}</span>
             <span style="float: left;" *ngIf="box.IsPallet == true;">{{'Pallet' | translate}}</span>
             <span style="float: left;">#{{j + 1}}</span>
            </div>

            <div class="ParcelMultiplyContainer">
              <input type="number" min="1" max="10" class="ParcelMultiplyInput" [(ngModel)]="box.MultiplyFactor" placeholder="1" (click)="$event.target.select()" (blur)="MultiplyBox(box, j);" (keydown.enter)="$event.target.blur();" (keydown.tab)="MultiplyBox(box, j);">
              <i class="material-icons ParcelMultiplyIcon" (click)="MultiplyBox(box, j);" title="{{'Multiply' | translate}}">close</i>
            </div>

            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{ 'Length' | translate }}*</mat-label>
              <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{ 'Width' | translate }}*</mat-label>
              <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX">close</i>
    
            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{ 'Height' | translate }}*</mat-label>
              <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <mat-form-field appearance="outline" class="ParcelDimention">
              <mat-label>{{this.ShippingDetails?.WeightType?.Name}}*</mat-label>
              <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
            </mat-form-field>
    
            <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>
    
            <div class="auto-save-toggle-container PalletToggle">
              <label class="auto-save-toggle">
                <input type="checkbox" [(ngModel)]="box.IsPallet">
                <span class="toggle-slider"></span>
              </label>
              <span class="auto-save-label">{{'Pallet' | translate}}?</span>
            </div>
    
            <div class="boxStatus" *ngIf="box.ID > 0;">
              <i class="material-icons">check</i>
            </div>
    
            <i class="material-icons ParcelDeleteIcon" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;">remove_circle_outline</i>
          </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;" style="border:none;">
      <div class="SectionTitle">
          {{'AWBCreationSettings' | translate}}
      </div>

      <div class="SelectedOptionsContainer">
          <div *ngFor="let type of this.DownloadTypes" class="SelectedOption" (click)="SelectDownloadType(type);">
              <!-- Download (ID = 1) -->
              <i class="material-icons" *ngIf="type.ID == this.CreateShippingLabelSettings?.DownloadType?.ID && type.ID == 1;">download</i>
              <i class="material-icons" *ngIf="type.ID != this.CreateShippingLabelSettings?.DownloadType?.ID && type.ID == 1;" style="color: #fff;">download</i>
              <!-- Print (ID = 2) -->
              <i class="material-icons" *ngIf="type.ID == this.CreateShippingLabelSettings?.DownloadType?.ID && type.ID == 2;">print</i>
              <i class="material-icons" *ngIf="type.ID != this.CreateShippingLabelSettings?.DownloadType?.ID && type.ID == 2;" style="color: #fff;">print</i>
              <!-- Fallback for other types -->
              <i class="material-icons" *ngIf="type.ID == this.CreateShippingLabelSettings?.DownloadType?.ID && type.ID != 1 && type.ID != 2;">check</i>
              <i class="material-icons" *ngIf="type.ID != this.CreateShippingLabelSettings?.DownloadType?.ID && type.ID != 1 && type.ID != 2;" style="color: #fff;">check</i>
              <span>{{type.Name}}</span>
          </div>
      </div>

      <div class="LabelEmailContainer">
        <div class="auto-save-toggle-container">
          <label class="auto-save-toggle">
            <input type="checkbox" [(ngModel)]="this.CreateShippingLabelSettings.SendEmail" (change)="ViewEmailSettings();">
            <span class="toggle-slider"></span>
          </label>
          <span class="auto-save-label">{{'SendLabelToPartner' | translate}}</span>
        </div>
      </div>

      <div class="LabelEmailContainer">
        <button mat-raised-button color="primary" class="TransportButton" *ngIf="this.CreateShippingLabelSettings.SendEmail == true;" (click)="ViewEmailSettings();">
          <i class="material-icons">settings</i>
          <span>{{'ViewEmailSettings' | translate}}</span>
        </button>
      </div>
      
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;">
      <button mat-raised-button class="AddressButton" (click)="OpenCompareShippingCosts();">
        <i class="material-icons">local_shipping</i>
        <i class="material-icons">linear_scale</i>
        <span>{{'CompareShippingCosts' | translate}}</span>
      </button>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;" style="border:none;margin-top: 25px;">
     
      <button mat-raised-button color="primary" class="BigButton" (click)="SimulateShippingCost();" style="background: #32aa3a;">
        <i class="material-icons" style="color: #000;">start</i>  
        <i class="material-icons" style="color: #000;">payment</i>
        <span>{{'GetShippingCost' | translate}}</span>
      </button>

      <div class="ButtonPressInfo" *ngIf="this.ShippingDetails?.Price != null && this.ShippingDetails?.Price?.UIUnitPrice != null && this.ShippingDetails?.Price?.Currency != null;">
        <i *ngIf="this.ShippingDetails.ShowDetailedShippingPrice == false" (click)="ShowPriceDetails();" class="material-icons">keyboard_arrow_right</i>
        <i *ngIf="this.ShippingDetails.ShowDetailedShippingPrice == true" (click)="ShowPriceDetails();" class="material-icons">keyboard_arrow_down</i>
        <p>{{'ShippingCost' | translate}}: <span>{{this.ShippingDetails?.Price?.UIUnitPrice}} {{this.ShippingDetails?.Price?.Currency?.Name}}</span> [{{'Receptions.Table.PriceNOVAT' | translate}}]</p>
      
        <div *ngIf="this.ShippingDetails.ShowDetailedShippingPrice == true">
          <p class="DetailedShippingPriceEntry" *ngFor="let entry of this.ShippingDetails.DetailedShippingPriceEntries;">
            {{entry?.Index}} - {{entry?.Value}} {{entry?.Currency?.Name}} ({{entry?.Description}})
          </p>
        </div>
      </div>
    </div>

    <div class="TransportSection" *ngIf="this.showBottom == true && !TaskCompleted;" style="border:none;">
      <button mat-raised-button color="primary" class="BigButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == 1;" (click)="CreateShippingLabel(false);">
          <i class="material-icons">verified</i>
          <span>{{'GenerateLabel' | translate}}</span>
      </button>

      <button mat-raised-button color="primary" class="BigButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == -1;" (click)="CreateShippingLabel(false);">
        <i class="material-icons">verified</i>
          <span>{{'GenerateLabel' | translate}}</span>
      </button>

      <button mat-raised-button color="primary" class="BigButton" *ngIf="this.ShippingDetails.ShippingDirection?.ID == -1;" (click)="CreateShippingLabel(true);">
          <i class="material-icons">verified</i>
          <i class="material-icons">group_add</i>
          <span>{{'GenerateAndPickup' | translate}}</span>
      </button>
      <div style="font-size: 11px; color: #888; margin: 10px 0 0 0; font-style: italic; width: 100%; float: left;">
          <i class="material-icons" style="font-size: 13px; vertical-align: middle; margin-right: 3px;">info_outline</i>{{'DocumentConnectionDisclaimer' | translate}}
      </div>
    </div>

    <div class="TransportInfoSection" *ngIf="TaskCompleted == true;">
      <div class="CongratsContainer">
        <i class="material-icons">verified</i>
        <span>{{'ProcessSuccessfullyCompleted' | translate}}</span>
      </div>

      <div class="TransportInfoSectionMainMessage">
        <!-- Copy to Clipboard Button -->
        <div class="CopyToClipboardButton"
             [class.copied]="CopiedToClipboard"
             (click)="CopyTransportInfoToClipboard();"
             matTooltip="{{ (CopiedToClipboard ? 'Copied!' : 'CopyToClipboard') | translate }}"
             matTooltipClass='neutral-tool-tip-management'>
          <i class="material-icons" *ngIf="!CopiedToClipboard">content_copy</i>
          <i class="material-icons" *ngIf="CopiedToClipboard">check</i>
        </div>

        <p>{{this.ShippingDetails?.ShippingDetailsText}}</p>
        <p *ngIf="ShippingDetails?.TrackingLabel?.length > 0;">{{ 'TrackingLabel' | translate}}: <span>{{ShippingDetails.TrackingLabel}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.CarrierPickupNumber?.length > 0;">{{ 'PickupNumber' | translate}}: <span>{{ShippingDetails.PickupInformation.CarrierPickupNumber}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.PickupDateUI?.length > 0;">{{ 'PickupDate' | translate}}: <span>{{ShippingDetails.PickupInformation.PickupDateUI}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.PickupEarliestUI?.length > 0;">{{ 'PickupEarliest' | translate}}: <span>{{ShippingDetails.PickupInformation.PickupEarliestUI}}</span></p>
        <p *ngIf="ShippingDetails?.PickupInformation?.PickupLatestUI?.length > 0;">{{ 'PickupLatest' | translate}}: <span>{{ShippingDetails.PickupInformation.PickupLatestUI}}</span></p>
        <p *ngIf="ShippingDetails?.ShippingServiceType?.Name?.length > 0;">{{ 'ShippingServiceType' | translate}}: <span>{{ShippingDetails.ShippingServiceType.Name}}</span></p>
        <p *ngIf="ShippingDetails?.ShippingWay?.Name?.length > 0;">{{ 'ShippingWay' | translate}}: <span>{{ShippingDetails.ShippingWay.Name}}</span></p>
      </div>

      <button mat-raised-button color="primary" class="BigButton" (click)="ReDownloadDocuments(1);">
          <i class="material-icons">download</i>
          <span>{{'ReDownloadLabel' | translate}}</span>
      </button>

      <button mat-raised-button color="primary" class="BigButton" (click)="ReDownloadDocuments(2);">
        <i class="material-icons">print</i>
        <span>{{'RePrintLabel' | translate}}</span>
    </button>

    <div style="width: 100%;float: left;margin-top: 50px;">
      <button mat-raised-button color="primary" class="ConclusionButton" (click)="this.parent.ReloadPage();">
        <i class="material-icons">add</i>
        <span>{{'GenerateTrackingLabel' | translate}}</span>
      </button>
    </div>
  </div>
</div>